/**
 * Lightweight global notification system.
 * Components call `showNotification(message)` to display a toast.
 * The `useNotificationListener` hook in App.tsx subscribes to these events.
 */

type NotificationListener = (message: string) => void;

const listeners: Set<NotificationListener> = new Set();

/** Display a global toast notification with the given message. */
export function showNotification(message: string): void {
  listeners.forEach((listener) => listener(message));
}

/** Subscribe to notification events. Returns an unsubscribe function. */
export function onNotification(listener: NotificationListener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
